// extracted by mini-css-extract-plugin
module.exports = {"button":"Error404_button__Rf55t"};